import { APIProvider, APIProviderProps } from '@vis.gl/react-google-maps';

import { env } from '@/config/env';
import { DEFAULT_LOCALE } from '@/models/localization.model';

type TMapsProviderProps = Omit<APIProviderProps, 'apiKey'>;

const MapsProvider = ({ language = DEFAULT_LOCALE, ...props }: TMapsProviderProps) => (
  <APIProvider {...props} language={language} apiKey={env.GOOGLE_MAPS_KEY} />
);

export default MapsProvider;
